import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
          <i className="ri-error-warning-line text-3xl"></i>
        </div>
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-flex px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line mr-2"></i>返回首页
        </Link>
      </div>
    </div>
  );
}